import React, { createContext, useContext, useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);

  const isAuthenticated = !!localStorage.getItem("access_token");

  useEffect(() => {
    const init = async () => {
      if (!isAuthenticated) {
        setLoading(false);
        return;
      }

      try {
        const { data } = await axiosInstance.get("users/me/");
        setUser(data);
        setOrganization(data.organization);
      } catch(error){
            if (error.response?.status === 401) {
                logout();
            }
      } finally {
        setLoading(false);
      }
    };

    init();
  }, []);

  const login = async ({ username, password }) => {
    const { data } = await axiosInstance.post("token/", { username, password });

    localStorage.setItem("access_token", data.access);
    localStorage.setItem("refresh_token", data.refresh);

    const me = await axiosInstance.get("users/me/");
    setUser(me.data);
    setOrganization(me.data.organization);
  };

  const logout = () => {
    localStorage.clear();
    setUser(null);
    setOrganization(null);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        organization,
        isAuthenticated,
        loading,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
